var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96875 3H10C10.6562 3 11.2188 3.4375 11.4375 4.03125L11.75 5H14C15.0938 5 16 5.90625 16 7V15C16 16.125 15.0938 17 14 17H2C0.875 17 0 16.125 0 15V7C0 5.90625 0.875 5 2 5H4.21875L4.53125 4.03125C4.75 3.4375 5.3125 3 5.96875 3ZM5.46875 4.34375L5.03125 5.6875C4.96875 5.875 4.78125 6 4.5625 6H2C1.4375 6 1 6.46875 1 7V15C1 15.5625 1.4375 16 2 16H14C14.5312 16 15 15.5625 15 15V7C15 6.46875 14.5312 6 14 6H11.4062C11.1875 6 11 5.875 10.9375 5.65625L10.5 4.34375C10.4062 4.15625 10.2188 4 10 4H5.96875C5.75 4 5.5625 4.15625 5.46875 4.34375ZM8 14.5C6.71875 14.5 5.59375 13.8438 4.96875 12.75C4.3125 11.6875 4.3125 10.3438 4.96875 9.25C5.59375 8.1875 6.71875 7.5 8 7.5C9.25 7.5 10.375 8.1875 11 9.25C11.6562 10.3438 11.6562 11.6875 11 12.75C10.375 13.8438 9.25 14.5 8 14.5ZM5.5 11C5.5 11.9062 5.96875 12.7188 6.75 13.1875C7.5 13.625 8.46875 13.625 9.25 13.1875C10 12.7188 10.5 11.9062 10.5 11C10.5 10.125 10 9.3125 9.25 8.84375C8.46875 8.40625 7.5 8.40625 6.75 8.84375C5.96875 9.3125 5.5 10.125 5.5 11Z",
    fill: "#181C21",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.75c3e636c9c74c698c789f76a0eaf659.svg";
export { ForwardRef as ReactComponent };